/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Bannerdescription1Inputs */

const en_auth_bannerdescription1 = /** @type {(inputs: Auth_Bannerdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover Celestial's all-in-one platform designed to support every stage of your investment journey – from initial research to the subscription process, and post-investment reporting data – all seamlessly integrated in one place.`)
};

/**
* | output |
* | --- |
* | "Discover Celestial's all-in-one platform designed to support every stage of your investment journey – from initial research to the subscription process, and ..." |
*
* @param {Auth_Bannerdescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_bannerdescription1 = /** @type {((inputs?: Auth_Bannerdescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Bannerdescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_bannerdescription1(inputs)
});
export { auth_bannerdescription1 as "auth_bannerDescription" }